import { AddToBasketStep } from "../Steps/AddToBasket/AddToBasketStep";
import { AddToBasketStepData } from "../Steps/AddToBasket/Models/AddToBasketStepData";
import { PackageFromCustomerStepData } from "../Steps/PackageFromCustomer/Models/PackageFromCustomerStepData";
import { PackageFromCustomerStep } from "../Steps/PackageFromCustomer/PackageFromCustomerStep";
import { PackageToCustomerStepData } from "../Steps/PackageToCustomer/Models/PackageToCustomerStepData";
import { PackageToCustomerStep } from "../Steps/PackageToCustomer/PackageToCustomerStep";
import { PaymentStepData } from "../Steps/Payment/Models/PaymentStepData";
import { PaymentReturnStep } from "../Steps/Payment/PaymentReturnStep";
import { PaymentStep } from "../Steps/Payment/PaymentStep";
import { PersonalPickupStepData } from "../Steps/PersonalPickup/Models/PersonalPickupStepData";
import { PersonalPickupStep } from "../Steps/PersonalPickup/PersonalPickupStep";
import { PersonalReturnStepData } from "../Steps/PersonalReturn/Models/PersonalReturnStepData";
import { PersonalReturnStep } from "../Steps/PersonalReturn/PersonalReturnStep";
import { Step } from "../Steps/Step/Step";
import { StepRawData } from "../Steps/Step/StepRawData";
import { StepType } from "../Steps/Step/StepType";
import { TrainingStepData } from "../Steps/Training/Models/TrainingStepData";
import { TrainingStep } from "../Steps/Training/TrainingStep";
import { UsageStepData } from "../Steps/Usage/Models/UsageStepData";
import { UsageStep } from "../Steps/Usage/UsageStep";
import { AgentsProvider } from "./Agents/AgentsProvider";
import { DateTimeProvider } from "./DateTimeProvider";
import { ManaPostalDeliveryStepData } from "../Steps/ManaPostalDelivery/Models/ManaPostalDeliveryStepData";
import { ManaPostalDeliveryStep } from "../Steps/ManaPostalDelivery/ManaPostalDeliveryStep";
import { InvoiceStepData } from "../Steps/Invoice/Models/InvoiceStepData";
import { InvoiceStep } from "../Steps/Invoice/InvoiceStep";
import { EventStep } from "../Steps/Event/EventStep";
import { EventStepData } from "../Steps/Event/Models/EventStepData";


export class StepFactory
{
    constructor(private _agents: AgentsProvider) 
    { }

    public StepsLabels: Record<string, StepType> = {
        "🛒 Zamówienie": StepType.AddToBasket,
        "⚡ Zdarzenie": StepType.Event,
        "💳 Płatność": StepType.Payment,
        "📦 Wysyłka do klienta": StepType.PackageToCustomer,
        "🐤 Odbiór osobisty": StepType.PersonalPickup,
        "🎓 Szkolenie": StepType.Training,
        "🚀 Użytkowanie": StepType.Usage,
        "📦 Zwrot paczką": StepType.PackageFromCustomer,
        "💰 Przekaz pieniężny": StepType.ManaPostalDelivery,
        "🐤 Zwrot osobisty": StepType.PersonalReturn,
        "💸 Zwrot kasy": StepType.PaymentReturn,
        "📃 Faktura": StepType.Invoice,
    };

    public Create<D extends StepRawData>(type: StepType, data?: Partial<D>): Step<any>
    {
        if (!data)
            data = { CreatedAt: DateTimeProvider.Now } as Partial<D>;

        switch (type)
        {
            case StepType.AddToBasket: return new AddToBasketStep(new AddToBasketStepData(data));
            case StepType.PackageToCustomer: return new PackageToCustomerStep(new PackageToCustomerStepData(data));
            case StepType.PackageFromCustomer: return new PackageFromCustomerStep(new PackageFromCustomerStepData(data));
            case StepType.PersonalPickup: return new PersonalPickupStep(this._agents, new PersonalPickupStepData(data));
            case StepType.PersonalReturn: return new PersonalReturnStep(new PersonalReturnStepData(data));
            case StepType.Training: return new TrainingStep(new TrainingStepData(data));
            case StepType.Payment: return new PaymentStep(new PaymentStepData(data));
            case StepType.PaymentReturn: return new PaymentReturnStep(new PaymentStepData(data));
            case StepType.Usage: return new UsageStep(this._agents, new UsageStepData(data));
            case StepType.ManaPostalDelivery: return new ManaPostalDeliveryStep(new ManaPostalDeliveryStepData(data));
            case StepType.Invoice: return new InvoiceStep(new InvoiceStepData(data));
            case StepType.Event: return new EventStep(new EventStepData(data));
            default: throw new Error(`Unknown Step type "${type}"`);
        }
    }
}
